import angular from 'angular';

angular
  .module('cxRelations')
  .controller('RelNewCtrl', ['$state', 'userData', 'flySvc', relNewCtrl]);

function relNewCtrl($state, userData, flySvc) {
  var vm = this;

  vm.success = function(relation, isNew) {
    if (!relation) return;

    userData.update('relSections', function(value) {
      value = value || {};
      value.relDashboard = true;
      value['3fd70070-f8c0-45a4-b3f2-23afff37061f'] = true;
      return value;
    });

    return $state
      .go('relations.detail', {
        relId: relation.id,
      })
      .then(function() {
        if (isNew) flySvc.success('msgNewRelCreated');
      });
  };
}
